<template>
  <div>
    <!-- 吸顶导航 -->
    <van-sticky>
      <van-nav-bar
        style="background-color: #3f78f6; margin-bottom: 0rem; border: 0"
        title=""
        left-text=""
        left-arrow
        @click-left="onClickLeft"
      >
        <template #title>
          <span style="color: white; font-size: 0.4rem">修改密码</span>
        </template>
        <template #left>
          <van-icon name="arrow-left" color="white" size="18" />
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-form class="van-form" style="margin-top: 20px" @submit="onSubmit">
      <van-field
        v-model="pass"
        label="原密码"
        name="pass"
        type="password"
        placeholder="请输原密码"
        :rules="[{ required: true, message: '请输入原密码' }]"
      />
      <van-field
        v-model="newpass"
        label="新密码"
        name="newpass"
        type="password"
        placeholder="请输新密码"
        :rules="[{ required: true, message: '请输入新密码' }]"
        style="margin-top: 20px"
      />
      <van-field
        v-model="recpass"
        label="确认密码"
        name="recpass"
        type="password"
        placeholder="请输入确认密码"
        :rules="[{ required: true, message: '请输入确认密码' }]"
        style="margin-top: 20px"
      />
      <div style="margin: 16px; margin-top: 40px">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      code: "",
      pass: "",
      newpass: "",
      recpass: "",
    };
  },
  created() {
    var json = window.localStorage.getItem("User");
    var jsonObj = JSON.parse(json);
    console.log("身份:" + jsonObj[0]["shenfen"]);
    var code;
    if (jsonObj[0]["shenfen"] == "老师") {
      code = jsonObj[0]["number"];
    } else if (jsonObj[0]["shenfen"] == "学生") {
      code = jsonObj[0]["number"];
    } else {
      code = jsonObj[0]["phone"];
    }
    this.code = code;
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
      if (values.newpass != values.recpass) {
        this.$notify({
          type: "warning",
          message: "两次密码输入不一致!",
        });
        return;
      } else {
        var params_json = {
          userid: this.code,
          action: "changepwd",
          param1: values.pass,
          param2: values.newpass,
          param3:"",
          param4: "",
          param5: "",
        };
        this.$http.post("/web/save", params_json).then(function (res) {
          let obj = res.data;
          console.log("注册后返回消息:" + obj.msg);
          if (obj.msg == "0") {
            this.$notify({
              type: "success",
              message: "操作成功。",
            });
            setTimeout(() => {
              this.$router.push("MyTeacher");
            }, 3000);
          } else {
            this.$notify({
              type: "warning",
              message: "密码修改失败！",
            });
          }
        });
      }
    },
    onClickLeft() {
      this.$router.push("MyTeacher");
    },
    onClickRight() {
      // 危险通知
      this.$toast("失败文案");
    },
  },
};
</script>
<style>
.van-doc-demo-block__title {
  margin: 0;
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
}

.van-doc-demo-block__card {
  margin: 12px 12px 0;
  overflow: hidden;
  border-radius: 8px;
}

.van-doc-demo-block__title + .van-doc-demo-block__card {
  margin-top: 0;
}

.van-doc-demo-block:first-of-type .van-doc-demo-block__title {
  padding-top: 20px;
}
</style>
<style>
.demo-col {
  background: #fff;
}

.demo-col .van-doc-demo-block {
  padding: 0 16px;
}

.demo-col .van-doc-demo-block__title {
  padding-left: 0;
}

.demo-col .van-col {
  margin-bottom: 10px;
  color: #fff;
  font-size: 13px;
  line-height: 30px;
  text-align: center;
  background-clip: content-box;
}

.demo-col .van-col:nth-child(odd) {
  background-color: #39a9ed;
}

.demo-col .van-col:nth-child(even) {
  background-color: #66c6f2;
}
</style>